import { useContext, useEffect, useState } from "react";
import Context from "../../../../common/components/utils/context";
import Moment from "react-moment";
import { MdDeleteForever, MdOutlineViewInAr } from "react-icons/md";
import { notifcation } from "../../../../common/components/utils/notifications";
import { Themes } from "../../../../common/enums/themes";
import { POIsV1Service } from "../../../../common/services/api/api";
import { IPOI } from "../../../matterportViewer/matterportViewer3";
import { RxArrowUp, RxHeight, RxWidth } from "react-icons/rx";
import { CiCompass1 } from "react-icons/ci";
import { getPOIUrl } from "../../../../common/components/route/routeHelpers";
import { useNavigate } from "react-router-dom";

export const POIFiles = () => {
  const context = useContext(Context);
  let navigate = useNavigate();

  const [update, setUpdate] = useState(true);
  const [selected, setSelected] = useState<IPOI>();
  const [POIFiles, setPOIFiles] = useState<IPOI[]>([]);

  useEffect(() => {
    loadPOIFiles();
  }, []);

  useEffect(() => {
    if (update) {
      loadPOIFiles().then(() => setUpdate(false));
    }
  }, [update]);

  const loadPOIFiles = async () => {
    const poiService = new POIsV1Service();
    const response = await poiService.getPOIs();
    setPOIFiles(response.data);
  };

  const view = (item: IPOI) => {
    navigate(getPOIUrl(item.id));
  };

  const remove = async (item: IPOI) => {
    const confirm = await notifcation({
      title: "Confirm Delete",
      message: `Are your sure you want to delete ${item.id} ?`,
      cancel: "Cancel",
      confirm: "Delete",
    });
    if (confirm) {
      const poiService = new POIsV1Service();

      const response = await poiService.delete(item.id);
      if (response.status === 204) {
        setUpdate(true);
        context.setAlert({
          message: "POI File deleted successfully!",
          theme: Themes.Success,
        });
      } else {
        context.setAlert({
          message: "Failed to delete POI File!",
          theme: Themes.Danger,
        });
      }
    }
  };

  return (
    <div className="border rounded-lg">
      <table className="border-collapse table-auto w-full text-sm">
        <thead>
          <tr>
            <th className="border-b border-r font-medium p-4 py-3 text-slate-400 text-left">
              <div className="flex flex-row space-x-2 items-center">Name</div>
            </th>
            <th className="border-b border-r font-medium p-4 py-3 text-slate-400 text-left">
              <div className="flex flex-row space-x-2 items-center">
                Position
              </div>
            </th>
            <th className="border-b border-r font-medium p-4 py-3 text-slate-400 text-left">
              <div className="flex flex-row space-x-2 items-center">Date</div>
            </th>
            <th
              className="border-b font-medium p-4 py-3 text-slate-400 text-left"
              colSpan={2}
            >
              <div className="flex flex-row space-x-2 items-center">
                Actions
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {POIFiles.map((item: IPOI) => (
            <tr
              key={item.id}
              className="cursor-pointer border-b last-of-type:border-b-0 hover:bg-gray-50"
            >
              <td
                className="border-r p-4 text-slate-500"
                onClick={() => setSelected(item)}
              >
                {item.name}
              </td>
              <td
                className="border-r p-4 text-slate-500"
                onClick={() => setSelected(item)}
              >
                <div className="flex flex-row gap-x-5">
                  <div
                    className="flex flex-row gap-x-2 items-center"
                    title={`Latitude: ${item.latitude}`}
                  >
                    <RxHeight /> {item.latitude}
                  </div>
                  <div
                    className="flex flex-row gap-x-2 items-center"
                    title={`Longitude: ${item.longitude}`}
                  >
                    <RxWidth /> {item.longitude}
                  </div>
                  <div
                    className="flex flex-row gap-x-2 items-center"
                    title={`Altitude: ${item.altitude}`}
                  >
                    <RxArrowUp /> {item.altitude}
                  </div>
                  <div
                    className="flex flex-row gap-x-2 items-center"
                    title={`Heading: ${item.heading}`}
                  >
                    <CiCompass1 /> {item.heading}
                  </div>
                </div>
              </td>
              <td
                className="border-r last-of-type:border-r-0 p-4 text-slate-500"
                onClick={() => setSelected(item)}
              >
                <Moment date={item.created} format="DD/MM/YYYY" />
              </td>
              <td
                className="border-r last-of-type:border-r-0 p-4 text-slate-500 hover:text-logo"
                onClick={() => view(item)}
              >
                <MdOutlineViewInAr size={20} title="View" className="mx-auto" />
              </td>
              <td
                className="border-r last-of-type:border-r-0 p-4 text-slate-500 hover:text-red-400"
                onClick={() => remove(item)}
              >
                <MdDeleteForever size={20} title="Delete" className="mx-auto" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
